const cards = {

	$window: $(window),

	elem: {
		$body: $('body'),
		$facultyCardLinks: $('.card .card__link')
	},

	init() {

		this.bindUIActions();

	},

	bindUIActions() {

		this.elem.$facultyCardLinks.hover(function() {
			$(this).parents('.card').addClass('card--hover');
		}, function () {
			$(this).parents('.card').removeClass('card--hover');
		});

	}

};

export {cards};
